// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__HR2A2","productName":"Table_productName__1S5GC"};